import { siteInfo } from "@/mocks/home";

export default function Header() {
  return (
    <header className="fixed top-0 left-0 w-full z-50 bg-black border-b border-stone-900">
      <nav className="flex items-center justify-between w-full px-6 md:px-12 py-5">
        <a href="/" className="flex items-center">
          <img
            src="https://public.readdy.ai/ai/img_res/edited_1b7fd2733b1c203128672bde6811c5a4_9b93e45f.jpg"
            alt={siteInfo.name}
            className="h-28 md:h-36 w-auto object-contain drop-shadow-2xl"
          />
        </a>
        <div className="flex items-center gap-6 md:gap-10">
          <a href="#video" className="text-base md:text-lg text-stone-300 hover:text-amber-500 transition-colors whitespace-nowrap font-medium drop-shadow-md">
            Vídeo
          </a>
          <a href="#inauguracao" className="text-base md:text-lg text-stone-300 hover:text-amber-500 transition-colors whitespace-nowrap font-medium drop-shadow-md">
            Inauguração
          </a>
          <a href="#contato" className="text-base md:text-lg text-stone-300 hover:text-amber-500 transition-colors whitespace-nowrap font-medium drop-shadow-md">
            Contato
          </a>
        </div>
      </nav>
    </header>
  );
}